import { List, Datagrid, TextField, EditButton, TextInput } from 'react-admin'

import FilterComponent from '../../components/Filter'

const CoachFilter = props => (
  <FilterComponent {...props}>
    <TextInput label="Search" source="name" alwaysOn />
  </FilterComponent>
)

const CoachList = props => (
  <List
    {...props}
    filters={<CoachFilter />}
    sort={{ field: 'id', order: 'DESC' }}>
    <Datagrid bulkActionButtons={false} rowClick={false}>
      <TextField source="id" />
      <TextField source="name" />
      <EditButton />
    </Datagrid>
  </List>
)

export default CoachList
